<template>
	<layout-admin>
		<div class="py-6 px-4 sm:px-6 lg:px-8">
			<ui-alert
				v-if="success"
				type="success"
				:message="success == true ? 'Your inputs have been saved!' : success"
			/>
			<ui-alert v-if="error" type="error" :message="error" />

			<div class="pb-8 px-6 fixed bottom-0 flex right-0 z-10">
				<ui-button
					class="ml-auto text-lg shadow-xl"
					label="Save"
					v-on:click="submitForm()"
					:disabled="submitButtonDisabled"
				/>
			</div>

			<h1 class="text-3xl font-semibold text-gray-900 mb-4">
				{{ __("Marktkompass Ausgabe") }} {{ formattedDate }}
				{{ __("bearbeiten") }}
			</h1>

			<div class="pb-8 px-6 fixed top-24 flex right-0 z-10">
				<ui-button
					type="secondary"
					v-on:click="$inertia.visit(backUrl)"
					class="flex items-center"
				>
					{{ __("Back") }}
				</ui-button>
			</div>

			<div class="pb-8 px-6 fixed top-24 flex right-28 z-10">
				<ui-button
					type="button"
					class="bg-red-500 rounded-lg shadow-sm py-2 px-4 font-medium text-white focus:ring-2 focus:ring-red-200"
					v-on:click="showDeleteModal = true"
					>{{ __("Delete") }}</ui-button
				>
				<ui-modal
					v-if="showDeleteModal"
					:small="true"
					:key="'MODAL_' + showDeleteModal"
					v-on:close="showDeleteModal = false"
					ref="deleteModal"
					:confirm-label="__('Delete')"
					v-on:confirm="deleteNews()"
					>{{ __("Do you want to delete this news?") }}</ui-modal
				>
			</div>

			<admin-market-news-fields :form="form" />
		</div>
		<div class="mt-4">
			<admin-crop-grid
				:title="'Beiträge'"
				:rows="newsItems"
				:cols="itemCols"
				v-bind:row-href="rowHref"
				defaultOrderBy="market_news_items_order"
				:defaultOrderByAscending="true"
				:showActionButton="true"
				:noWrap="false"
				:actionButtonCaption="'Create'"
				:actionButtonTarget="createUrl"
			/>
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";
let options = require("../../cropOptions");
export default {
	props: {
		news: {
			type: Object,
			required: true,
		},
		newsItems: {
			type: Array,
			required: true,
		},
		success: {
			default: false,
		},
		error: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.news)),
			submitButtonDisabled: false,
			formattedDate: options.formatIsoStamp(this.news.release_at),
			itemCols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "title",
					name: this.__("Title"),
				},
				{
					id: "title_image",
					name: this.__("Title Image"),
				},
				{
					id: "text",
					name: this.__("Text"),
				},
				{
					id: "market_news_items_order",
					name: this.__("Order"),
				},
			],
			showDeleteModal: false,
		};
	},
	computed: {
		backUrl() {
			return window.baseUrl + "/admin/market-news";
		},
		createUrl() {
			return (
				window.baseUrl + "/admin/market-news/" + this.news.id + "/create-item"
			);
		},
	},
	created() {
		//console.log(this.initialData);
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
		rowHref(row) {
			return (
				window.baseUrl + "/admin/market-news/item/" + row.id.replace("#", "")
			);
		},
		async deleteNews() {
			let endpoint = window.baseUrl + "/admin/market-news/" + this.news.id;
			this.$inertia.delete(endpoint);
			this.showDeleteModal = false;
			this.$emit("close");
		},
	},
};
</script>
